export const iconFontAwesomeUsersPeoplePersonSkiing = (
	<i className="fa-solid fa-person-skiing"></i>
);
